import React from 'react';
import ApiError from 'components/common/ApiError';
import Skeleton from 'react-loading-skeleton';
import { useComponentDetails } from 'hooks/useComponentDetails';
import { API_ENDPOINTS } from 'constants';
import InputList from 'components/common/InputList';
import DetailCard from 'components/list/DetailCard';
import { OBJ } from 'constants';

import { faChild, faHandsHelping, faHeart } from '@fortawesome/free-solid-svg-icons';

export const CONTACT_RELATIONSHIP_TYPE = [
    { value: 'child', label: 'contact_relationships.options.type.child', icon: faChild },
    { value: 'spouse', label: 'contact_relationships.options.type.spouse', icon: faHeart },
    { value: 'helper', label: 'contact_relationships.options.type.helper', icon: faHandsHelping },
];

export const contactRelationshipItems = [
    { label: 'contact_relationships.label.type', icon: 'link', key: 'type', type: 'iconSelect', options: CONTACT_RELATIONSHIP_TYPE },
    { label: 'contact_relationships.label.to_contact_id', icon: 'person', key: 'to_contact_id', type: 'link', options: OBJ.CUSTOMERS, readOnly: true },
];

const ContactRelationshipDetails = ({ selectedItem, list }) => {
    const { data, saveKey, isLoading, error, saveError, success, refetch, toolbar } =
        useComponentDetails(API_ENDPOINTS.CONTACT_RELATIONSHIPS.ITEM(selectedItem.id), list);
    
    const toolbarItems = [toolbar.back, toolbar.delete, toolbar.undelete];

    if (isLoading) return <Skeleton height={30} count={20} />;
    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message} />;

    return (
        <DetailCard toolbarItems={toolbarItems} success={success} saveError={saveError}>
            <InputList fields={contactRelationshipItems} data={data} onChange={saveKey} />
        </DetailCard>
    );
};

export default ContactRelationshipDetails;
